export default __webpack_public_path__ + "static/media/blog05.22cf6ce1.png";